import { render, staticRenderFns } from "./GeneralAppearance.vue?vue&type=template&id=045feb7a&"
import script from "./GeneralAppearance.vue?vue&type=script&lang=js&"
export * from "./GeneralAppearance.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports